import cronstrue from "cronstrue";
import "cronstrue/locales/es";

export type CrontabLocale = "en" | "es";

/**
 * Turns a crontab string into a short natural-language description.
 * On parse errors, returns the original string so the UI never breaks.
 */
export function formatCrontabHumanReadable(
  crontab: string,
  locale: CrontabLocale
): string {
  const trimmed = crontab.trim();
  if (!trimmed) {
    return "";
  }

  try {
    return cronstrue.toString(trimmed, {
      locale: locale === "es" ? "es" : "en",
      use24HourTimeFormat: locale === "es",
    });
  } catch {
    return trimmed;
  }
}
